import { hasAnyPermission, hasPermission, PERM } from '../accessPermissions';
import { PENDING_ORDER_TAB_PERMS } from './dashboardOrderPendingTabs';

const HOME_DASHBOARD_SECTION_IDS = {
	STAT_CARDS: 'statCards',
	HOME_CHARTS: 'homeCharts',
	PROCESSING_ORDERS: 'processingOrders',
	OVERDUE: 'overdue',
};

const ALL_SECTION_IDS = Object.values(HOME_DASHBOARD_SECTION_IDS);

export const canAccessHomeDashboardSection = (userInfo, sectionId) => {
	if (!userInfo || !sectionId || !Array.isArray(userInfo.access)) return false;

	switch (sectionId) {
		case HOME_DASHBOARD_SECTION_IDS.STAT_CARDS:
			return hasPermission(userInfo, PERM.MENU_DASHBOARD_STAT_CARDS);
		case HOME_DASHBOARD_SECTION_IDS.OVERDUE:
			return hasPermission(userInfo, PERM.MENU_DASHBOARD_OVERDUE);
		case HOME_DASHBOARD_SECTION_IDS.HOME_CHARTS:
			return hasPermission(userInfo, PERM.MENU_DASHBOARD_HOME_CHARTS);
		case HOME_DASHBOARD_SECTION_IDS.PROCESSING_ORDERS:
			return hasAnyPermission(userInfo, PENDING_ORDER_TAB_PERMS);
		default:
			return false;
	}
};

export const getAvailableHomeDashboardSectionIds = (userInfo) =>
	ALL_SECTION_IDS.filter((sectionId) => canAccessHomeDashboardSection(userInfo, sectionId));

/** 登录用户都能进首页；布局自定义跟着页面走 */
export const canAccessDashboardPage = (userInfo) => Boolean(userInfo);

export const canEditHomeDashboardLayout = (userInfo) => canAccessDashboardPage(userInfo);
